import errorMesseage from './errorMesseage';
import notification from './notification';

const lookup = { notification, errorMesseage };

export default lookup;
